module.exports = __webpack_public_path__ + "static/media/Logout.e9344e4e.svg";